export default __webpack_public_path__ + "static/media/Buy-Reinvest - Icon.cacfcfec.svg";